import { render, staticRenderFns } from "./big-report.vue?vue&type=template&id=27296a32&scoped=true&"
import script from "./big-report.vue?vue&type=script&lang=js&"
export * from "./big-report.vue?vue&type=script&lang=js&"
import style0 from "./big-report.vue?vue&type=style&index=0&id=27296a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27296a32",
  null
  
)

export default component.exports